/**
 * Home Dashboard Page
 * Features "Continue Watching" and "Recently Added" content
 */
class HomePage {
    constructor(app) {
        this.app = app;
        this.container = null; // Will be set in renderLayout
        this.isLoading = false;
        // Guards playItem() - a slower getStreamUrl()/seriesInfo round trip
        // from an earlier card click must not invoke watch.play() after a
        // faster later click already did (same pattern as ChannelList /
        // MoviesPage / SeriesPage's own selection generation guards).
        this.playSelectionGeneration = 0;
    }

    async init() {
        // Initialization if needed
    }

    async show() {
        this.renderLayout();
        await this.loadDashboardData();
    }

    hide() {
        // Cleanup if needed
        if (this.container) {
            this.container.innerHTML = '';
        }
    }

    renderLayout() {
        const pageHome = document.getElementById('page-home');
        if (!pageHome) return;

        pageHome.innerHTML = `
            <div class="dashboard-content" id="home-content">
                <section class="dashboard-section" id="favorite-channels-section">
                    <div class="section-header">
                        <h2>Favorite Channels</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll channel-tiles" id="favorite-channels-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading favorites...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>

                <section class="dashboard-section" id="continue-watching-section">
                    <div class="section-header">
                        <h2>Continue Watching</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll" id="continue-watching-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading history...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>

                <div id="new-for-you-container"></div>

                <div id="recommendations-container"></div>

                <section class="dashboard-section" id="latest-movies-section">
                    <div class="section-header">
                        <h2>Latest Movie Releases</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll" id="latest-movies-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading latest releases...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>

                <section class="dashboard-section" id="latest-series-section">
                    <div class="section-header">
                        <h2>Latest Series Releases</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll" id="latest-series-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading latest releases...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>

                <div id="genre-rows-container"></div>

                <section class="dashboard-section">
                    <div class="section-header">
                        <h2>Recently Added Movies</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll" id="recent-movies-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading recently added...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>

                <section class="dashboard-section">
                    <div class="section-header">
                        <h2>Recently Added Series</h2>
                    </div>
                    <div class="scroll-wrapper">
                        <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                        </button>
                        <div class="horizontal-scroll" id="recent-series-list">
                            <div class="loading-state">
                                <div class="loading"></div>
                                <span>Loading recently added...</span>
                            </div>
                        </div>
                        <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                        </button>
                    </div>
                </section>
            </div>
        `;
        this.container = document.getElementById('home-content');

        // Attach scroll arrow handlers
        this.initScrollArrows();
    }

    initScrollArrows(root = this.container) {
        root.querySelectorAll('.scroll-wrapper').forEach(wrapper => this.wireScrollWrapper(wrapper));
    }

    // Split out of initScrollArrows so dynamically-injected sections (e.g.
    // recommendation rows, whose count/titles aren't known until fetch time)
    // can wire up just their own new wrappers without re-binding listeners
    // onto the four static sections a second time.
    wireScrollWrapper(wrapper) {
        const scrollContainer = wrapper.querySelector('.horizontal-scroll');
        const leftBtn = wrapper.querySelector('.scroll-left');
        const rightBtn = wrapper.querySelector('.scroll-right');

        if (!scrollContainer || !leftBtn || !rightBtn) return;

        const scrollAmount = 300; // pixels to scroll per click

        leftBtn.addEventListener('click', () => {
            scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        rightBtn.addEventListener('click', () => {
            scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        // Update arrow visibility based on scroll position
        const updateArrows = () => {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
            leftBtn.classList.toggle('hidden', scrollLeft <= 0);
            rightBtn.classList.toggle('hidden', scrollLeft + clientWidth >= scrollWidth - 5);
        };

        // Store reference for later updates
        wrapper._updateArrows = updateArrows;

        scrollContainer.addEventListener('scroll', updateArrows);
        // Initial check after content loads
        setTimeout(updateArrows, 100);
    }

    /**
     * Re-check scroll arrow visibility for all sections
     * Call this after dynamically loading content
     */
    updateScrollArrows() {
        this.container?.querySelectorAll('.scroll-wrapper').forEach(wrapper => {
            if (wrapper._updateArrows) {
                wrapper._updateArrows();
            }
        });
    }


    async loadDashboardData() {
        if (this.isLoading) return;
        this.isLoading = true;

        try {
            // Load all four rows in parallel. Previously these ran serially
            // with Favorite Channels first - and resolving favorites pulls the
            // ENTIRE live-channel catalog (channelList.loadChannels) to match
            // logos, so Continue Watching and Recently Added Movies/Series
            // (which don't need channel data at all) were stuck waiting behind
            // that heavy load. allSettled so one row failing doesn't abort the
            // others.
            await Promise.allSettled([
                this.renderFavoriteChannels(),
                this.renderHistorySection(),
                this.renderNewForYou(),
                this.renderRecommendations(),
                this.renderLatestMovies(),
                this.renderLatestSeries(),
                this.renderRecentMovies(),
                this.renderRecentSeries(),
                this.renderGenreRows(),
            ]);
        } catch (err) {
            console.error('[Dashboard] Error loading data:', err);
        } finally {
            this.isLoading = false;
        }
    }

    async renderHistorySection() {
        try {
            const history = await window.API.request('GET', '/history?limit=12');
            if (history && Array.isArray(history)) {
                this.renderHistory(history);
            }
        } catch (err) {
            console.error('[Dashboard] Error loading history:', err);
        }
    }

    async renderFavoriteChannels() {
        const list = document.getElementById('favorite-channels-list');
        const section = document.getElementById('favorite-channels-section');
        if (!list || !section) return;

        try {
            // Resolve favorite channels server-side (name/logo/streamId) so this
            // row renders without loading the entire ~47k-channel catalog just to
            // look up a handful of logos. The full catalog is still loaded lazily
            // when the user actually clicks into the Guide to play (see
            // playChannel), which is where it's genuinely needed.
            const channels = await window.API.favorites.getResolvedChannels();

            if (!channels || channels.length === 0) {
                list.innerHTML = '<div class="empty-state hint">Add channels to favorites from Live TV</div>';
                return;
            }

            // Keep the resolved objects around so the click handler can hand
            // the full channel data straight to the player (streamId/sourceType/
            // url), without having to re-look it up in the big channel catalog.
            this.favoriteChannels = channels;

            // Render channel tiles
            list.innerHTML = channels.map(ch => this.createChannelTile(ch)).join('');

            // Attach click handlers
            list.querySelectorAll('.channel-tile').forEach(tile => {
                tile.addEventListener('click', () => {
                    const ch = this.favoriteChannels.find(c => String(c.id) === String(tile.dataset.channelId));
                    if (ch) this.playChannel(ch);
                });
            });

            // Update scroll arrows after content renders
            this.updateScrollArrows();

        } catch (err) {
            console.error('[Dashboard] Error loading favorite channels:', err);
            list.innerHTML = '<div class="empty-state hint">Error loading favorites</div>';
        }
    }

    createChannelTile(channel) {
        const logo = channel.tvgLogo || '/img/placeholder.png';
        const logoUrl = logo.startsWith('http') ? `/api/proxy/image?url=${encodeURIComponent(logo)}&w=128` : logo;
        const name = escapeHtml(channel.name || 'Unknown');

        return `
            <div class="channel-tile" tabindex="0" data-channel-id="${channel.id}" data-source-id="${channel.sourceId}">
                <div class="tile-logo">
                    <img src="${logoUrl}" alt="${name}" loading="lazy" onerror="this.onerror=null;this.src='/img/placeholder.png'">
                </div>
                <div class="tile-name" title="${name}">${name}</div>
            </div>
        `;
    }

    async playChannel(channel) {
        // `channel` is a fully-resolved favorite (from /api/favorites/channels):
        // { id, name, sourceId, sourceType, streamId, url, tvgLogo }. Navigate
        // to the TV Guide (the sole live-tv view) and play it directly from that
        // data - selectChannel() falls back to the passed-in fields when the
        // channel isn't in the loaded list, so playback starts immediately
        // instead of waiting on the full ~47k-channel catalog load (the Guide
        // still loads its own channel grid in the background for the schedule).
        await this.app.navigateTo('guide');

        const channelList = this.app.channelList;
        if (!channelList) return;

        channelList.selectChannel({
            channelId: channel.id,
            sourceId: channel.sourceId,
            sourceType: channel.sourceType,
            streamId: channel.streamId || '',
            url: channel.url || '',
            name: channel.name,
            tvgLogo: channel.tvgLogo || ''
        });
    }

    renderHistory(items) {
        const list = document.getElementById('continue-watching-list');
        const section = document.getElementById('continue-watching-section');

        if (!list || !section) return;

        if (items.length === 0) {
            section.classList.add('hidden');
            return;
        }

        section.classList.remove('hidden');
        list.innerHTML = items.map(item => this.createCard(item)).join('');

        // Attach click listeners
        list.querySelectorAll('.dashboard-card').forEach(card => {
            card.addEventListener('click', () => {
                const id = card.dataset.id;
                const item = items.find(i => i.item_id === id);
                if (item) {
                    const type = item.item_type || item.type;

                    // IF it's a series, checking details is better than blind resume
                    // BUT for "Continue Watching", we ideally want to resume

                    // Prioritize playing directly for resume tiles
                    this.playItem(item, true); // true for resume
                }
            });
        });

        // Remove-from-history button - stopPropagation so it doesn't also
        // trigger the card's own play handler above.
        list.querySelectorAll('.card-remove-btn').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                e.stopPropagation();
                const id = btn.dataset.removeId;
                const card = btn.closest('.dashboard-card');
                try {
                    await window.API.request('DELETE', `/history/${id}`);
                    card?.remove();
                    if (!list.querySelector('.dashboard-card')) {
                        section.classList.add('hidden');
                    } else {
                        this.updateScrollArrows();
                    }
                } catch (err) {
                    console.error('[Dashboard] Failed to remove history item:', err);
                }
            });
        });

        // Update scroll arrows after content renders
        this.updateScrollArrows();
    }

    async navigateToSeries(item) {
        // Prepare the series object as expected by SeriesPage.showSeriesDetails
        const series = {
            series_id: item.item_id,
            sourceId: item.source_id,
            // See createCard() above for why both title/poster (web) and
            // name/stream_icon (Android) field names must be checked.
            name: item.name || (item.data ? (item.data.title || item.data.name) : 'Series'),
            cover: item.stream_icon || (item.data ? (item.data.poster || item.data.stream_icon) : null),
            plot: item.data ? item.data.description : '',
            year: item.data ? item.data.year : ''
        };

        // Switch page (awaits the lazy import on first visit, so the page
        // controller is guaranteed to exist by the time we use it below -
        // replaces a previous setTimeout(..., 100) guess that could race
        // a network-fetched chunk under lazy-loading).
        await this.app.navigateTo('series');

        this.app.pages.series.showSeriesDetails(series);
    }

    async renderRecommendations() {
        const container = document.getElementById('recommendations-container');
        if (!container) return;

        try {
            const result = await window.API.request('GET', '/recommendations/home?limit=12');
            if (!result) return;

            const { becauseYouWatched = [], topPicks = [], coldStart } = result;
            const sections = [];

            if (coldStart || becauseYouWatched.length === 0) {
                if (topPicks.length > 0) {
                    sections.push(this.buildRecommendationSection('popular-picks', 'Popular Picks', topPicks));
                }
            } else {
                becauseYouWatched.forEach((row, i) => {
                    if (!row.items || row.items.length === 0) return;
                    sections.push(this.buildRecommendationSection(
                        `because-watched-${i}`,
                        `Because You Watched "${row.seedTitle}"`,
                        row.items
                    ));
                });
                if (topPicks.length > 0) {
                    sections.push(this.buildRecommendationSection('top-picks', 'Recommended For You', topPicks));
                }
            }

            if (sections.length === 0) {
                container.innerHTML = '';
                return;
            }

            container.innerHTML = sections.join('');

            // Items are only known after this fetch resolves, so click
            // handlers/scroll arrows are wired here rather than up front.
            const allItems = [...becauseYouWatched.flatMap(row => row.items || []), ...topPicks];
            container.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = allItems.find(i => String(i.item_id) === String(id));
                    if (!item) return;
                    const type = item.item_type || item.type;
                    if (type === 'series') this.navigateToSeries(item);
                    else this.playItem(item);
                });
            });
            // Scoped to this container only - initScrollArrows() over the
            // whole page would double-bind the four static sections' listeners.
            container.querySelectorAll('.scroll-wrapper').forEach(wrapper => this.wireScrollWrapper(wrapper));
        } catch (err) {
            console.error('[Dashboard] Error loading recommendations:', err);
        }
    }

    /**
     * Genre browse shelves (Horror Movies, Comedies, ...) - GET
     * /api/channels/genre-rows, see HOME_GENRE_ROWS in server/routes/channels.js
     * for the curated per-type list. Not personalized/watched-filtered (unlike
     * Recommendations above) - same content for every user, a plain browse
     * aid like Latest/Recently Added.
     */
    async renderGenreRows() {
        const container = document.getElementById('genre-rows-container');
        if (!container) return;

        try {
            const [movieRows, seriesRows] = await Promise.all([
                window.API.request('GET', '/channels/genre-rows?type=movie'),
                window.API.request('GET', '/channels/genre-rows?type=series')
            ]);
            const rows = [
                ...(movieRows || []).map(r => ({ ...r, label: `${r.genre} Movies` })),
                ...(seriesRows || []).map(r => ({ ...r, label: `${r.genre} Series` }))
            ];
            if (rows.length === 0) {
                container.innerHTML = '';
                return;
            }

            const sections = rows.map(({ label, items }, i) =>
                this.buildRecommendationSection(`genre-row-${i}`, label, items)
            );
            container.innerHTML = sections.join('');

            const allItems = rows.flatMap(r => r.items);
            container.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = allItems.find(i => String(i.item_id) === String(id));
                    if (!item) return;
                    const type = item.item_type || item.type;
                    if (type === 'series') this.navigateToSeries(item);
                    else this.playItem(item);
                });
            });
            container.querySelectorAll('.scroll-wrapper').forEach(wrapper => this.wireScrollWrapper(wrapper));
        } catch (err) {
            console.error('[Dashboard] Error loading genre rows:', err);
        }
    }

    buildRecommendationSection(id, title, items, cardBuilder) {
        const builder = cardBuilder || (item => this.createRecentCard(item));
        return `
            <section class="dashboard-section" id="${id}">
                <div class="section-header">
                    <h2>${title}</h2>
                </div>
                <div class="scroll-wrapper">
                    <button class="scroll-arrow scroll-left" aria-label="Scroll left">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                    </button>
                    <div class="horizontal-scroll">
                        ${items.map(item => builder(item)).join('')}
                    </div>
                    <button class="scroll-arrow scroll-right" aria-label="Scroll right">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
                    </button>
                </div>
            </section>
        `;
    }

    /**
     * "New Season Available" (watched series with more seasons/episodes than
     * when marked watched) and "Recently Added For You" (movies sharing a
     * genre with movies marked watched, sorted by catalog add time - NOT
     * release date, so a 1950 title can legitimately show up here if it was
     * just added to the provider's catalog; the label used to say "New
     * Releases For You", which read as a release-date claim it never made -
     * see GET /api/recommendations/new-for-you and
     * server/services/newContentDetector.js. Derived from the explicit
     * watched list, not watch history, so it stays empty until the user
     * actually marks something as watched.
     */
    async renderNewForYou() {
        const container = document.getElementById('new-for-you-container');
        if (!container) return;

        try {
            const result = await window.API.request('GET', '/recommendations/new-for-you?limit=12');
            if (!result) return;

            const { newSeasons = [], newMovies = [] } = result;
            const sections = [];

            if (newSeasons.length > 0) {
                sections.push(this.buildRecommendationSection(
                    'new-seasons', 'New Season Available', newSeasons,
                    item => this.createNewSeasonCard(item)
                ));
            }
            if (newMovies.length > 0) {
                sections.push(this.buildRecommendationSection(
                    'new-releases', 'Recently Added For You', newMovies,
                    item => this.createNewReleaseCard(item)
                ));
            }

            if (sections.length === 0) {
                container.innerHTML = '';
                return;
            }

            container.innerHTML = sections.join('');

            const allItems = [...newSeasons, ...newMovies];
            container.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = allItems.find(i => String(i.item_id) === String(id));
                    if (!item) return;
                    const type = item.item_type || item.type;
                    if (type === 'series') this.navigateToSeries(item);
                    else this.playItem(item);
                });
            });
            container.querySelectorAll('.scroll-wrapper').forEach(wrapper => this.wireScrollWrapper(wrapper));
        } catch (err) {
            console.error('[Dashboard] Error loading new-for-you:', err);
        }
    }

    createNewSeasonCard(item) {
        const { data, item_id } = item;
        const poster = item.stream_icon || (data && data.poster) || '/img/poster-placeholder.jpg';
        const posterUrl = poster.startsWith('http') ? `/api/proxy/image?url=${encodeURIComponent(poster)}&w=300` : poster;
        const badgeText = item.newSeasonCount > 0
            ? `Season ${item.currentSeasonCount}`
            : `+${item.newEpisodeCount} New`;
        const rating = item.rating ? `${Icons.star} ${item.rating}` : '';
        const year = item.year_num || item.year || (data && data.year) || '';

        return `
            <div class="dashboard-card" tabindex="0" data-id="${item_id}" data-type="series">
                <div class="card-image">
                    <img src="${posterUrl}" alt="${escapeHtml(item.name)}" loading="lazy" onerror="this.onerror=null;this.src='/img/poster-placeholder.jpg'">
                    <div class="new-badge">${badgeText}</div>
                    <div class="play-icon-overlay">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                </div>
                <div class="card-info">
                    <div class="card-title" title="${escapeHtml(item.name)}">${escapeHtml(item.name || 'Unknown Title')}</div>
                    <div class="card-subtitle">New Season Available</div>
                    ${rating || year ? `<div class="card-meta">${rating ? `<span>${rating}</span>` : ''}${year ? `<span>${year}</span>` : ''}</div>` : ''}
                </div>
            </div>
        `;
    }

    createNewReleaseCard(item) {
        const { data, item_id } = item;
        const poster = item.stream_icon || (data && data.poster) || '/img/poster-placeholder.jpg';
        const posterUrl = poster.startsWith('http') ? `/api/proxy/image?url=${encodeURIComponent(poster)}&w=300` : poster;
        const rating = item.rating ? `${Icons.star} ${item.rating}` : '';
        const year = item.year_num || item.year || '';

        return `
            <div class="dashboard-card" tabindex="0" data-id="${item_id}" data-type="movie">
                <div class="card-image">
                    <img src="${posterUrl}" alt="${escapeHtml(item.name)}" loading="lazy" onerror="this.onerror=null;this.src='/img/poster-placeholder.jpg'">
                    <div class="new-badge">NEW</div>
                    <div class="play-icon-overlay">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                </div>
                <div class="card-info">
                    <div class="card-title" title="${escapeHtml(item.name)}">${escapeHtml(item.name || 'Unknown Title')}</div>
                    <div class="card-subtitle">Movie</div>
                    ${rating || year ? `<div class="card-meta">${rating ? `<span>${rating}</span>` : ''}${year ? `<span>${year}</span>` : ''}</div>` : ''}
                </div>
            </div>
        `;
    }

    /**
     * "Latest Releases" - sorted by actual release date (GET
     * /api/channels/latest), distinct from "Recently Added" below (sorted by
     * when the item entered the catalog). Movies results are sparse until
     * the background TMDB backfill has processed more of the ~200k-movie
     * catalog - see server/routes/channels.js.
     */
    async renderLatestMovies() {
        const list = document.getElementById('latest-movies-list');
        const section = document.getElementById('latest-movies-section');
        if (!list) return;

        try {
            const movies = await window.API.request('GET', '/channels/latest?type=movie&limit=12');
            if (!movies || movies.length === 0) {
                section?.classList.add('hidden');
                return;
            }
            section?.classList.remove('hidden');

            list.innerHTML = movies.map(item => this.createRecentCard(item)).join('');

            list.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = movies.find(m => m.item_id === id);
                    if (item) this.playItem(item);
                });
            });

            this.updateScrollArrows();
        } catch (err) {
            console.error('[Dashboard] Error loading latest movie releases:', err);
        }
    }

    async renderLatestSeries() {
        const list = document.getElementById('latest-series-list');
        const section = document.getElementById('latest-series-section');
        if (!list) return;

        try {
            const series = await window.API.request('GET', '/channels/latest?type=series&limit=12');
            if (!series || series.length === 0) {
                section?.classList.add('hidden');
                return;
            }
            section?.classList.remove('hidden');

            list.innerHTML = series.map(item => this.createRecentCard(item)).join('');

            list.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = series.find(s => s.item_id === id);
                    if (item) this.navigateToSeries(item);
                });
            });

            this.updateScrollArrows();
        } catch (err) {
            console.error('[Dashboard] Error loading latest series releases:', err);
        }
    }

    async renderRecentMovies() {
        const list = document.getElementById('recent-movies-list');
        if (!list) return;

        try {
            const movies = await window.API.request('GET', '/channels/recent?type=movie&limit=12');
            if (!movies || movies.length === 0) {
                list.innerHTML = '<div class="empty-state hint">No recently added movies found</div>';
                return;
            }

            list.innerHTML = movies.map(item => this.createRecentCard(item)).join('');

            // Attach listeners
            list.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = movies.find(m => m.item_id === id);
                    if (item) this.playItem(item);
                });
            });

            // Update scroll arrows after content renders
            this.updateScrollArrows();
        } catch (err) {
            console.error('[Dashboard] Error loading recent movies:', err);
        }
    }

    async renderRecentSeries() {
        const list = document.getElementById('recent-series-list');
        if (!list) return;

        try {
            const series = await window.API.request('GET', '/channels/recent?type=series&limit=12');
            if (!series || series.length === 0) {
                list.innerHTML = '<div class="empty-state hint">No recently added series found</div>';
                return;
            }

            list.innerHTML = series.map(item => this.createRecentCard(item)).join('');

            // Attach listeners
            list.querySelectorAll('.dashboard-card').forEach(card => {
                card.addEventListener('click', () => {
                    const id = card.dataset.id;
                    const item = series.find(s => s.item_id === id);
                    if (item) this.navigateToSeries(item);
                });
            });

            // Update scroll arrows after content renders
            this.updateScrollArrows();
        } catch (err) {
            console.error('[Dashboard] Error loading recent series:', err);
        }
    }

    createCard(item) {
        const { data, progress, duration, item_id } = item;
        const type = item.item_type || item.type;
        // Guard against duration being 0/missing, which would make the ratio
        // NaN/Infinity and render the progress bar as `width: NaN%`.
        const percent = (duration > 0 && progress > 0)
            ? Math.min(100, Math.round((progress / duration) * 100))
            : 0;

        // The Android app writes this same watch_history.data blob shape
        // with different field names (name/stream_icon) than the web app's
        // own saveProgress() (title/poster) - without this fallback, any
        // item last progressed from the Android app rendered with no title
        // and no poster in Continue Watching here.
        const title = data.title || data.name;
        // Proxy the poster if it's an external URL
        const poster = data.poster || data.stream_icon || '/img/poster-placeholder.jpg';
        const posterUrl = poster.startsWith('http') ? `/api/proxy/image?url=${encodeURIComponent(poster)}&w=300` : poster;
        // rating/year come from the watch_history data snapshot saveProgress()
        // saves - only present going forward from 2026-08-15; older rows saved
        // before that fix just show nothing here rather than erroring.
        const rating = data.rating ? `${Icons.star} ${data.rating}` : '';
        const year = data.year || '';

        return `
            <div class="dashboard-card" tabindex="0" data-id="${item_id}" data-type="${type}">
                <div class="card-image">
                    <img src="${posterUrl}" alt="${escapeHtml(title || item.name)}" loading="lazy" onerror="this.onerror=null;this.src='/img/poster-placeholder.jpg'">
                    <div class="progress-bar-container">
                        <div class="progress-bar" style="width: ${percent}%"></div>
                    </div>
                    <div class="play-icon-overlay">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                    <button class="card-remove-btn" title="Remove from Continue Watching" data-remove-id="${item_id}">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                    </button>
                </div>
                <div class="card-info">
                    <div class="card-title" title="${escapeHtml(item.name || title)}">${escapeHtml(item.name || title || 'Unknown Title')}</div>
                    <div class="card-subtitle">${escapeHtml(data.subtitle || (type === 'movie' ? 'Movie' : 'Series'))}</div>
                    ${rating || year ? `<div class="card-meta">${rating ? `<span>${rating}</span>` : ''}${year ? `<span>${year}</span>` : ''}</div>` : ''}
                </div>
            </div>
        `;
    }

    createRecentCard(item) {
        const { data, item_id } = item;
        const type = item.type || item.item_type;
        const poster = item.stream_icon || data.poster || '/img/poster-placeholder.jpg';
        const posterUrl = poster.startsWith('http') ? `/api/proxy/image?url=${encodeURIComponent(poster)}&w=300` : poster;
        const rating = item.rating ? `${Icons.star} ${item.rating}` : '';
        const year = item.year_num || item.year || (data && data.year) || '';

        return `
            <div class="dashboard-card" tabindex="0" data-id="${item_id}" data-type="${type}">
                <div class="card-image">
                    <img src="${posterUrl}" alt="${escapeHtml(item.name)}" loading="lazy" onerror="this.onerror=null;this.src='/img/poster-placeholder.jpg'">
                    <div class="play-icon-overlay">
                        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                    </div>
                </div>
                <div class="card-info">
                    <div class="card-title" title="${escapeHtml(item.name || (data && data.title))}">${escapeHtml(item.name || (data && data.title) || 'Unknown Title')}</div>
                    <div class="card-subtitle">${escapeHtml((data && data.subtitle) || (type === 'movie' ? 'Movie' : 'Series'))}</div>
                    ${rating || year ? `<div class="card-meta">${rating ? `<span>${rating}</span>` : ''}${year ? `<span>${year}</span>` : ''}</div>` : ''}
                </div>
            </div>
        `;
    }

    async playItem(item, isResume = false) {
        const mySelection = ++this.playSelectionGeneration;
        await this.app.ensurePage('watch');
        if (mySelection !== this.playSelectionGeneration) return; // a newer item selection has already taken over

        try {
            const type = item.item_type || item.type;
            const streamType = type === 'movie' ? 'movie' : 'series';
            const sourceId = item.source_id || (item.data && item.data.sourceId);
            let streamId = item.item_id;
            let container = item.container_extension || (item.data && item.data.containerExtension) || 'mp4';

            // The provider periodically renumbers a series and its episodes
            // wholesale when it rebuilds that part of its catalog (confirmed
            // live: the same title reappearing under a brand-new series id,
            // more than once for the same show) - so a resume episode's own
            // cached item_id from watch_history can go stale even though the
            // show itself is still very much there and browsable from the
            // Series page (which always resolves episode ids fresh via
            // series_info, never from a stored cache). Re-resolve the
            // CURRENT episode id from a fresh series_info lookup before
            // building the play URL, instead of trusting a potentially
            // months-old cached id - self-heals across a renumber. Falls
            // back to the cached id if the lookup fails or no longer lists
            // that exact season/episode (rare - e.g. an episode actually
            // pulled, not just renumbered).
            let seriesInfo = null;
            const seriesId = type === 'episode' && item.data ? item.data.seriesId : null;
            const currentSeason = type === 'episode' && item.data ? item.data.currentSeason : null;
            const currentEpisode = type === 'episode' && item.data ? item.data.currentEpisode : null;
            if (seriesId && sourceId) {
                try {
                    seriesInfo = await window.API.request('GET', `/proxy/xtream/${sourceId}/series_info?series_id=${seriesId}`);
                    if (mySelection !== this.playSelectionGeneration) return; // a newer item selection has already taken over
                    const seasonEpisodes = seriesInfo?.episodes?.[String(currentSeason)];
                    const freshEp = seasonEpisodes?.find(ep => String(ep.episode_num) === String(currentEpisode));
                    if (freshEp) {
                        streamId = freshEp.id;
                        container = freshEp.container_extension || container;
                    }
                } catch (e) {
                    console.warn('[Dashboard] Could not fetch seriesInfo to resolve current episode:', e);
                }
            }

            const result = await window.API.request('GET', `/proxy/xtream/${sourceId}/stream/${streamId}/${streamType}?container=${container}`);
            if (mySelection !== this.playSelectionGeneration) return; // a newer item selection has already taken over

            if (result && result.url) {
                const content = {
                    id: streamId,
                    // WatchPage.js's contentType convention (see its
                    // `this.contentType === 'series'` checks - onEnded(),
                    // updateNextEpisodeButton(), etc.) is only ever 'movie'
                    // or 'series', matching SeriesPage.js's playEpisode()
                    // which hardcodes 'series' even for a single episode.
                    // A Continue Watching row's raw item_type is 'episode'
                    // for an in-progress series (see watch_history's
                    // item_type column) - passing that straight through left
                    // contentType as 'episode', which matched NONE of those
                    // strict 'series' checks, so auto-advancing to the next
                    // episode (and the manual next-episode button) silently
                    // never worked when a series was resumed from Home,
                    // even though seriesInfo below was being fetched fine.
                    type: type === 'movie' ? 'movie' : 'series',
                    // See createCard()'s comment: the Android app writes this
                    // same watch_history.data blob with name/stream_icon
                    // instead of title/poster.
                    title: item.name || item.data.title || item.data.name,
                    subtitle: item.data.subtitle || (type === 'movie' ? 'Movie' : 'Series'),
                    poster: item.stream_icon || item.data.poster || item.data.stream_icon,
                    // `description` was missing entirely here - `item.data`
                    // is only ever populated with the small snapshot
                    // saveProgress() saves (title/subtitle/poster/etc, no
                    // description/rating/year), so a Continue Watching item
                    // falls through to the recommendation-shaped item's own
                    // top-level fields instead. See knowledge/streamcast.md.
                    description: item.data?.description || item.description || item.data?.plot || '',
                    rating: item.data?.rating ?? item.rating ?? null,
                    year: item.data?.year || item.year_num || item.year || '',
                    sourceId: sourceId,
                    resumeTime: isResume ? item.progress : 0,
                    containerExtension: container
                };

                // For episodes, restore series data for next-episode functionality
                // (seriesInfo was already fetched above, while resolving the
                // current episode's fresh stream id - no need to fetch it twice).
                if (type === 'episode' && item.data) {
                    content.seriesId = seriesId || null;
                    content.currentSeason = currentSeason || null;
                    content.currentEpisode = currentEpisode || null;
                    if (seriesInfo) content.seriesInfo = seriesInfo;
                }
                if (mySelection !== this.playSelectionGeneration) return; // a newer item selection has already taken over

                // Switch to watch page
                this.app.navigateTo('watch');

                this.app.pages.watch.play(content, result.url);
            } else {
                await this.app.ensurePage('watch');
                if (mySelection !== this.playSelectionGeneration) return;
                this.app.navigateTo('watch');
                this.app.pages.watch.showPlaybackError("Couldn't get a playable link for this title - it may have been removed or changed on the provider's end.");
            }
        } catch (err) {
            console.error('[Dashboard] Playback failed:', err);
            await this.app.ensurePage('watch');
            if (mySelection !== this.playSelectionGeneration) return;
            this.app.navigateTo('watch');
            this.app.pages.watch.showPlaybackError("Couldn't get a playable link for this title - it may have been removed or changed on the provider's end.");
        }
    }
}

window.HomePage = HomePage;
